import { GLOBAL_SEARCH_COMPONENT, globalSearchComponentDef } from 'navigation-components/config';
import { useComponentProps, useComponentState, useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback } from 'react';
import { GLOBAL_SEARCH_QUERY_PARAM } from '../constants';
// Handles the updating of URL query parameters using URLSearchParams.
const updateURLParams = (key, value) => {
  const urlQueryParams = new URLSearchParams(window.location.search);
  if (value === '' || value === undefined || Array.isArray(value) && !String(value)) {
    urlQueryParams.delete(key);
  } else {
    urlQueryParams.set(key, value.toString());
  }
  const paramString = urlQueryParams.toString() === '' ? window.location.pathname : `?${urlQueryParams.toString()}`;
  window.history.replaceState({}, '', paramString);
};
const useSearchComponent = (isMinified = false) => {
  const {
    isOpen
  } = useComponentState(GLOBAL_SEARCH_COMPONENT);
  const searchComponentProps = useComponentProps(globalSearchComponentDef);
  const {
    toggle: toggleSearchComponent
  } = useToggleComponent(GLOBAL_SEARCH_COMPONENT);
  const updateSearchComponentProps = useCallback(partialUpdate => {
    searchComponentProps(currentProps => Object.assign({}, currentProps, partialUpdate));
  }, [searchComponentProps]);
  const loadAndShowSearch = useCallback(searchData => {
    if (searchData) {
      const {
        searchQuery: query = '',
        searchFilters = '',
        searchPreFiltered = ''
      } = searchData;
      const searchQuery = query.substring(0, 512);
      updateSearchComponentProps({
        searchQuery,
        searchFilters,
        searchPreFiltered
      });
      if (!isMinified) updateURLParams(GLOBAL_SEARCH_QUERY_PARAM, searchQuery);
    }
    if (!isOpen) {
      toggleSearchComponent(true);
    }
  }, [isOpen, toggleSearchComponent, updateSearchComponentProps, isMinified]);
  return {
    loadAndShowSearch,
    updateSearchComponentProps,
    updateURLParams
  };
};
export default useSearchComponent;